import { projectService as ogpProjectService } from 'ogp/services';
import { projectService as hqProjectService } from 'hq/services';
import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { SiteDetectionResult, useSiteDetection } from '../../../../../../hooks';

export const useGetProjectCancellations = (workId: string) => {
  const siteDetectionResult = useSiteDetection();
  const queryFn = getQueryFunction(siteDetectionResult, workId);

  return useQuery(QUERY_KEYS.workApplicationsForProject(workId), queryFn);
};

function getQueryFunction(siteDetectionResult: SiteDetectionResult, workId: string) {
  if (siteDetectionResult.isHQ) {
    return async () => await hqProjectService.getProjectCancellations(workId);
  }

  if (siteDetectionResult.isOGP) {
    return async () => await ogpProjectService.getProjectCancellations(workId);
  }

  throw new Error(
    `useGetProjectCancellations: site "${siteDetectionResult}" is neither HQ nor OGP.`
  );
}
